const NS = 'WoolLabThemesBlock';
const CLS = 'woolLabThemesBlock';

import slick from 'slick-carousel';


export class WoolLabThemesBlock {

	constructor(el) {
		this.$el = $(el);
		this.$themesCarousel = this.$el.find(`.${CLS}-carousel`);

		this.initThemesCarousel();
	}

	initThemesCarousel() {
		const options = {
			arrows: true,
			infinite: false,
			dots: false,
			variableWidth: true,
			slidesToScroll: 3,
			prevArrow: "<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
      		nextArrow: "<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
			  responsive: [
				{
				  breakpoint: 1024,
				  settings: {
					slidesToScroll: 2,
				  }
				},
				{
				  breakpoint: 600,
				  settings: {
					slidesToScroll: 1
				  }
				},
				{
				  breakpoint: 480,
				  settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				  }
				}
			  ]
		};

		this.$themesCarousel.slick(options);
	}
}